<template>
  <v-container fluid class="pa-0">
    <div class="d-flex justify-space-between align-center flex-wrap">
      <div>
        <h2 class="subheading grey--text">{{ periodo.nombre }}</h2>
      </div>
      <div>
        <v-chip small :color="estadoColor(periodo.estado)" text-color="white" class="mr-2">{{ periodo.estado }}</v-chip>
        <v-btn outlined small @click="dialog = true"><v-icon left small>mdi-pencil</v-icon>Editar periodo</v-btn>
      </div>
    </div>

    <v-row class="mt-1">
      <v-col cols="12" sm="6" md="3">
        <v-card class="elevation-2 stat-card">
          <v-card-text>
            <v-icon color="primary" class="mb-2" large>mdi-calendar-range</v-icon>
            <div class="stat-value">{{ periodo.nombre.replace('Mesa Directiva ', '') }}</div>
            <div class="stat-label grey--text">Periodo</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="elevation-2 stat-card">
          <v-card-text>
            <v-icon color="blue" class="mb-2" large>mdi-clock-start</v-icon>
            <div class="stat-value">{{ periodo.inicio }}</div>
            <div class="stat-label grey--text">Inicio</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="elevation-2 stat-card">
          <v-card-text>
            <v-icon color="grey darken-1" class="mb-2" large>mdi-clock-end</v-icon>
            <div class="stat-value">{{ periodo.fin }}</div>
            <div class="stat-label grey--text">Finalización</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="elevation-2 stat-card">
          <v-card-text>
            <v-icon color="orange darken-1" class="mb-2" large>mdi-account-group-outline</v-icon>
            <div class="stat-value">{{ miembros.length }}</div>
            <div class="stat-label grey--text">Integrantes</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="7">
        <v-card class="elevation-2" style="height: 100%;">
          <v-card-title><v-icon color="primary" left>mdi-shield-account-outline</v-icon>Estructura de la mesa</v-card-title>
          <v-card-text>
            <div class="org-row justify-center">
              <div class="org-node presidente">
                <v-avatar size="56" color="primary"><span class="white--text font-weight-bold">{{ initials(presidente.name) }}</span></v-avatar>
                <div class="org-name">{{ presidente.name }}</div>
                <div class="org-role">{{ presidente.cargo }}</div>
              </div>
            </div>
            <div class="org-connector"></div>
            <div class="org-row justify-center">
              <div class="org-node" v-for="m in nivel2" :key="m.id">
                <v-avatar size="52" color="green lighten-4"><span class="green--text text--darken-3 font-weight-bold">{{ initials(m.name) }}</span></v-avatar>
                <div class="org-name">{{ m.name }}</div>
                <div class="org-role">{{ m.cargo }}</div>
              </div>
            </div>
            <div class="org-connector"></div>
            <div class="org-row justify-center">
              <div class="org-node" v-for="m in vocales" :key="m.id">
                <v-avatar size="52" color="green lighten-4"><span class="green--text text--darken-3 font-weight-bold">{{ initials(m.name) }}</span></v-avatar>
                <div class="org-name">{{ m.name }}</div>
                <div class="org-role">{{ m.cargo }}</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="5">
        <v-card class="elevation-2">
          <v-card-title><v-icon color="primary" left>mdi-cog-outline</v-icon>Cargos disponibles</v-card-title>
          <v-list dense>
            <v-list-item v-for="c in cargosDisponibles" :key="c">
              <v-list-item-content>{{ c }}</v-list-item-content>
              <v-list-item-action><v-icon small>mdi-pencil</v-icon></v-list-item-action>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-btn text color="primary" small @click="nuevoCargo()"><v-icon left small>mdi-plus</v-icon>Agregar cargo</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="420">
      <v-card class="elevation-5">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Editar periodo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <v-text-field v-model="form.inicio" label="Fecha de inicio" prepend-icon="mdi-calendar" outlined dense></v-text-field>
          <v-text-field v-model="form.fin" label="Fecha de finalización" prepend-icon="mdi-calendar" outlined dense></v-text-field>
          <v-select v-model="form.estado" :items="['Activa', 'Finalizada']" label="Estado" prepend-icon="mdi-checkbox-marked-circle-outline" outlined dense></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click="dialog = false">Cerrar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="guardarPeriodo()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { periodo, miembros, cargosDisponibles, estadoColor, initials } from './mesaDirectivaMockData'

export default {
  name: 'MesaDirectivaConfiguracion',
  data () {
    return {
      periodo,
      miembros,
      cargosDisponibles,
      dialog: false,
      form: { inicio: periodo.inicio, fin: periodo.fin, estado: periodo.estado }
    }
  },
  computed: {
    presidente () {
      return this.miembros.find(m => m.cargo === 'Presidente') || this.miembros[0]
    },
    nivel2 () {
      return this.miembros.filter(m => ['Vicepresidente', 'Secretario', 'Tesorero'].includes(m.cargo))
    },
    vocales () {
      return this.miembros.filter(m => m.cargo === 'Vocal')
    }
  },
  methods: {
    estadoColor,
    initials,
    nuevoCargo () {
      const cargo = window.prompt('Nombre del nuevo cargo')
      if (cargo) this.cargosDisponibles.push(cargo)
    },
    guardarPeriodo () {
      this.periodo.inicio = this.form.inicio
      this.periodo.fin = this.form.fin
      this.periodo.estado = this.form.estado
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_change_message', 'Periodo actualizado correctamente')
      this.$store.commit('snackbar_activate_true')
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.stat-card { text-align: center; height: 100%; }
.stat-value { font-size: 1.3rem; font-weight: 700; }
.stat-label { font-size: 0.85rem; }

.org-row {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}
.org-connector {
  width: 2px;
  height: 24px;
  background: #E0E0E0;
  margin: 4px auto;
}
.org-node {
  text-align: center;
  width: 110px;
}
.org-name {
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 6px;
}
.org-role {
  font-size: 0.7rem;
  color: #9E9E9E;
}
</style>
